import React from 'react';
import { View, Text } from '@smarterservices/smarter-ui';
import { usePlayerStore, getStore } from '../../../stores/StoreContext';
import { useEffect, useState, forwardRef } from 'react';
const ProgressBar = forwardRef((props, ref) => {
  {
    /* Listen to any changes in the stores... */
  }
  const duration = usePlayerStore((state) => state.duration);
  const currentTime = usePlayerStore((state) => state.currentTime);
  const isLive = usePlayerStore((state) => state.isLive);
  const dragging = usePlayerStore((state) => state.dragging);
  const playing = usePlayerStore((state) => state.playing);
  const scrubTime = usePlayerStore((state) => state.scrubTime);
  const smartSpeedEnabled = usePlayerStore((state) => state.smartSpeedEnabled);
  const smartSpeedPlaybackRanges = usePlayerStore((state) => state.smartSpeedPlaybackRanges);

  const PlayerStore = getStore('playerStore');

  const [color, setColor] = useState('brand');
  const [progressWidth, setProgressWidth] = useState(0);

  const height = 8;
  const smartSpeedIndictorHeight = height + 4;
  const borderRadius = 'medium';

  useEffect(() => {
    if (isLive) {
      setColor('success');
      setProgressWidth('100%');
    } else {
      if (currentTime > 0) {
        setProgressWidth(
          `${(dragging ? scrubTime / duration : currentTime / duration) * 100}%`
        );
      }

      setColor('brand');
    }
  }, [isLive, currentTime, duration]);

  const handleClickNav = (e) => {
    // Validate duration before calculating newTime
    if (!isFinite(duration) || duration <= 0) {
      console.warn('ProgressBar: Invalid duration for seeking:', duration);
      return;
    }

    const rect = ref.current.getBoundingClientRect();
    let relativeX = e.clientX - rect.left;
    relativeX = Math.max(0, Math.min(relativeX, rect.width));
    const newTime = (relativeX / rect.width) * duration;

    // Additional validation for newTime
    if (!isFinite(newTime)) {
      console.warn('ProgressBar: Calculated invalid newTime:', { relativeX, duration, newTime });
      return;
    }

    PlayerStore.jumpTo(newTime);
  };

  return (
    <View position="relative">

      {smartSpeedEnabled && (
        <>
          {smartSpeedPlaybackRanges.map((range, index) => (
            <>
              {range.speed > 1 && (
                <View
                  as="div"
                  position="absolute"
                  width={`${(((range.end ? range.end : duration) - range.start) / duration) * 100}%`}
                  withVisualDebug={false}
                  background="info"
                  borderRadius="medium"
                  height={`${smartSpeedIndictorHeight}px`}
                  style={{
                    top: '-2px',
                    left: `${(range.start / duration) * 100}%`,
                    zIndex: 99
                  }}
                >
                  &nbsp;
                </View>
              )}
            </>
          ))}
        </>
      )}
      <View
        as="div"
        className="base-progress-bar"
        position="relative"
        withVisualDebug={false}
        width="100%"
        borderRadius={borderRadius}
        background="primary"
        height={`${height}px`}
        cursor="pointer"
        onClick={handleClickNav}
        themeOverride={{
          backgroundPrimary: '#E0E0E0',
        }}
        style={{
          zIndex: 999
        }}
      >
        {/* If smart speed is enabled, show the skip points... */}

        <View
          as="div"
          position="relative"
          width={progressWidth}
          withVisualDebug={false}
          background={color}
          borderRadius={borderRadius}
          stacking="9999"
          height={`${height}px`}
        >
          &nbsp;
        </View>

      </View>

    </View>
  );
});

export default ProgressBar;
